import React, { useEffect } from "react";
import CheckboxInputCustom from "./CheckboxInputCustom";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface IOption {
  targetLanguageId: string;
}

interface Props {
  input: {
    value: string[] | undefined;
    onChange: (value: string[]) => void;
  };
  options: IOption[];
  languagePairSelected?: string[];
  action?: (selected: string[]) => void;
}

const MultiSelectCabolo: React.FC<Props> = ({
  input,
  options,
  languagePairSelected,
  action,
}) => {
  const selectedValues = Array.isArray(input.value) ? input.value : [];
  const [t] = useTranslation(["cabolo", "translation"], translationHookOptions);
  useEffect(() => {
    const fromPairs = Array.isArray(languagePairSelected) ? languagePairSelected : [];
    const merged = [...selectedValues, ...fromPairs].filter(
      (v, i, arr) => arr.indexOf(v) === i
    );

    if (merged.length !== selectedValues.length) {
      input.onChange(merged);
      action?.(merged); // chiama handleSelectedLanguages
    }
  }, [JSON.stringify(languagePairSelected)]);

  // Gestione selezione/deselezione
  const toggleValue = (val: string) => {
    const isSelected = selectedValues.includes(val);
    const newSelected = isSelected
      ? selectedValues.filter((v) => v !== val)
      : [...selectedValues, val];

    input.onChange(newSelected);
    action?.(newSelected); 
  };

  const ResolveLanguageTranscription = (targetLanguageId: string) => {

    switch (targetLanguageId) {
      case "ita":
        return t("it-IT", { ns: "translation" });
      case "eng":
        return t("en-US" , { ns: "translation" });
      case "fra":
        return t("fr-FR", { ns: "translation" });

      default:
        return targetLanguageId;
    }

  }

  return (
    <div>
      {options.map((opt) => {
        const isChecked = selectedValues.includes(opt.targetLanguageId);
        return (
          <CheckboxInputCustom
            key={opt.targetLanguageId}
            id={`lang_${opt.targetLanguageId}`}
            label={ResolveLanguageTranscription(opt.targetLanguageId)}
            input={{
              name: opt.targetLanguageId,
              type: "checkbox",
              value: opt.targetLanguageId,
               checked: isChecked,
              onChange: () => toggleValue(opt.targetLanguageId),
            }}
          />
        );
      })}
    </div>
  );
};

export default React.memo(MultiSelectCabolo);
